import { array, number, object, string } from "yup";

export const MAX_NUMBER_OF_ACTIVE_SURVEYS = 5;
export const MAX_NUMBER_OF_OPTIONS = 5;

export type DealSurvey = {
	description: string | null;
	enabledNote: boolean;
	id: number;
	surveyOptions: SurveyOption[];
	title: string;
};

export type DealSurveyOption = {
	id: number;
	text: string;
	value: number;
};

export type SurveyAnswers = {
	answers: SurveyAnswer[];
};

export type SurveyAnswer = {
	note: string | null;
	surveyOptionId: number;
};

export type Survey = {
	activatedAt: string | null;
	description: string | null;
	enabled: boolean;
	enabledNote: boolean;
	id: number;
	seq: number;
	surveyOptions: SurveyOption[];
	title: string;
};

export type SurveyOption = {
	id: number;
	seq: number;
	text: string;
	value: number;
};

export type SurveySetting = {
	activatedAt: string | null;
	description: string | null;
	enabled: boolean;
	enabledNote: boolean;
	id: number | null;
	seq: number | null;
	surveyOptions: SurveyOptionSetting[];
	title: string;
};

export type SurveyOptionSetting = {
	id: number | null;
	seq: number | null;
	text: string;
	value: number;
};

export type DealSurveyAnswer = {
	id: number;
	note: string | null;
	text: string;
	title: string;
};

export const validationSurveyAnswersSchema = object().shape({
	answers: array().of(
		object().shape({
			note: string().nullable().max(255, "255文字以内で設定してください"),
			surveyOptionId: number().nullable().required("選択してください")
		})
	)
});

export const validationSurveySchema = object().shape({
	description: string().nullable().max(255, "255文字以内で設定してください"),
	surveyOptions: array()
		.of(
			object().shape({
				text: string()
					.nullable()
					.required("入力してください")
					.max(255, "255文字以内で設定してください"),
				value: number()
					.max(5, "5以下で入力してください")
					.min(-5, "-5以上で入力してください")
			})
		)
		.test({
			message: "選択肢は最低2つ作成してください",
			test: (surveyOptions) =>
				surveyOptions !== undefined && surveyOptions.length >= 2
		}),
	title: string()
		.nullable()
		.required("入力してください")
		.max(255, "255文字以内で設定してください")
});

export const buildInitialSurveySetting: SurveySetting = {
	activatedAt: null,
	description: "",
	enabled: true,
	enabledNote: false,
	id: null,
	seq: null,
	surveyOptions: [
		{ id: null, seq: null, text: "", value: 0 },
		{ id: null, seq: null, text: "", value: 0 }
	],
	title: ""
};
